exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-dialog-container[data-v-d6a9d738]{text-align:left;line-height:1.5}.label-input-dialog[data-v-d6a9d738]{margin-top:0}.checkbox-element[data-v-d6a9d738]{margin-left:20px;margin-top:.5em}.color-picker-container[data-v-d6a9d738]{display:flex;align-items:center}.color-picker-label>label[data-v-d6a9d738]{margin-top:0;margin-bottom:0}.color-picker-label[data-v-d6a9d738]{flex-basis:33em}.description[data-v-d6a9d738]{font-size:1.2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d6a9d738","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/InputDialog.vue
// module id = 565
// module chunks = 38